import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { updateQuote } from '../api/quotesApi';

// Seeds ['quote', id] from the fresh VM so the details card's last-saved
// snapshot is authoritative without a GET round-trip. No success toast —
// the card's status pill already shows "Saved" per autosave tick.
export default function useUpdateQuote() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }) => updateQuote(id, body),
        onSuccess: (fresh) => {
            queryClient.setQueryData(['quote', fresh.id], fresh);
        },
        onError: (err) => toast.error(err?.message ?? 'Failed to save quote'),
    });
}
